import { Box } from 'theme-ui';
import './spinner.css';

export function SpinnerIcon(props: { size?: number; color?: string }) {
  const size = props.size || 26;
  const color = props.color || 'white';

  return (
    <Box
      as="svg"
      // @ts-ignore
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      className="spinner-icon"
      sx={{ stroke: color }}
    >
      <circle
        className="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="5"
      ></circle>
    </Box>
  );
}
